function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M23.416,30c-0.771,0-1.398-0.633-1.398-1.397c0-5.285-4.287-9.582-9.569-9.582 c-5.275,0-9.56,4.297-9.56,9.582c0,0.765-0.624,1.397-1.4,1.397c-0.772,0-1.397-0.633-1.397-1.397 c0-6.818,5.548-12.364,12.357-12.364c6.819,0,12.368,5.546,12.368,12.364C24.816,29.367,24.193,30,23.416,30z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M12.44,14.751c-3.514,0-6.37-2.858-6.37-6.381C6.07,4.856,8.926,2,12.44,2c3.509,0,6.371,2.856,6.371,6.37 C18.811,11.893,15.949,14.751,12.44,14.751z M12.44,4.802c-1.971,0-3.573,1.599-3.573,3.568c0,1.965,1.603,3.578,3.573,3.578 c1.978,0,3.576-1.613,3.576-3.578C16.016,6.4,14.417,4.802,12.44,4.802z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M38.514,30c-0.779,0-1.404-0.633-1.404-1.397c0-5.285-4.297-9.582-9.57-9.582 c-0.979,0-1.945,0.16-2.871,0.447c-0.738,0.238-1.523-0.174-1.75-0.91c-0.236-0.736,0.176-1.525,0.91-1.756 c1.189-0.377,2.445-0.563,3.711-0.563c6.822,0,12.369,5.546,12.369,12.364C39.908,29.367,39.279,30,38.514,30z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M27.531,14.751c-3.514,0-6.375-2.858-6.375-6.381c0-3.514,2.861-6.37,6.375-6.37 c3.506,0,6.363,2.856,6.363,6.37C33.895,11.893,31.037,14.751,27.531,14.751z M27.531,4.802c-1.973,0-3.582,1.599-3.582,3.568 c0,1.965,1.609,3.578,3.582,3.578c1.965,0,3.578-1.613,3.578-3.578C31.109,6.4,29.496,4.802,27.531,4.802z"
})));

var SvgGroupIcon = function SvgGroupIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "32px",
    viewBox: "0 0 40 32",
    enableBackground: "new 0 0 40 32",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroupIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/groupIcon.d8b7a22c.svg";
export { ForwardRef as ReactComponent };